import { round } from './math';


export interface CoordsType
{
  x: number,
  y: number,
}

export interface CoordsStartEndType
{
  x1: number,
  y1: number,
  x2: number,
  y2: number,
}

export interface XDistanceAngle
{
  x: number,
  angle: number,
  distance: number,
}

export interface YDistanceAngle
{
  y: number,
  angle: number,
  distance: number,
}

// **************************************

const SIN:Array<number> = [];
const COS:Array<number> = [];

(() =>
{
  for (let i = 0; i <= 360; i++) {
    COS[i] = Math.cos(i * Math.PI / 180);
    SIN[i] = Math.sin(i * Math.PI / 180) * -1;
  }
})();

export function getXByAngle(angle: number): number
{
  // return Math.cos(angle * Math.PI / 180);
  return COS[ round(angle % 360) ];
}

export function getYByAngle(angle: number): number
{
  // return Math.sin(angle * Math.PI / 180) * -1;
  return SIN[ round(angle % 360) ];
}

export function getAngleBy2XY({x1, x2, y1, y2}: CoordsStartEndType): number
{
  const deltaY = y2 - y1;
  const deltaX = x2 - x1;

  let theta = Math.atan2(-deltaY, deltaX);
  if (theta < 0)
    theta += 2 * Math.PI;

  const angle = round(theta * 180 / Math.PI);

  return angle;
}

export function getDistanceBy2XY({x1, x2, y1, y2}: CoordsStartEndType): number
{
  const dx = Math.pow(x2 - x1, 2);
  const dy = Math.pow(y1 - y2, 2);
  return Math.sqrt(dx + dy);
}

export function getXByDistanceAndAngle({x, angle, distance}: XDistanceAngle): number
{
  return (x + COS[ round(angle % 360) ] * distance);
}

export function getYByDistanceAndAngle({y, angle, distance}: YDistanceAngle): number
{
  return (y + SIN[ round(angle % 360) ] * distance);
}

export function getXYByDistanceAndAngle({x, y, angle, distance}: XDistanceAngle & YDistanceAngle): CoordsType
{
  return {
    x: getXByDistanceAndAngle({ x, angle, distance }),
    y: getYByDistanceAndAngle({ y, angle, distance }),
  }
}

export function getReverseAngle(angle: number): number
{
  return (angle + 180) % 360;
}

export function getDiffBetween2Angles(angle1: number, angle2: number): number
{
  let diff = Math.abs(angle1 - angle2);
  if (diff > 180)
    diff = 360 - diff;
  return diff;
}

export function getCorrectAngle(angle: number): number
{
  let newAngle = angle % 360;
  if (newAngle < 0)
    newAngle += 360;
  return newAngle;
}
